/* ==========================================================
   Mindkore Membership
   Custom enhancements for Easy Subscriptions
   ========================================================== */

/* ----------------------------------------------------------
   Language detection
   ---------------------------------------------------------- */

const documentLanguage = document.documentElement.lang.toLowerCase();

const language = documentLanguage.startsWith("nl")
    ? "nl"
    : documentLanguage.startsWith("de")
        ? "de"
        : "en";

const translations = {

    en: {

        membership: "Mindkore Membership",
        coreMembership: "Mindkore CORE Membership",
        apexMembership: "Mindkore APEX Membership",

        save: "⭐ 5% discount • Up to 15% over time",
        step: "STEP",

    },

    nl: {

        membership: "Mindkore Membership",
        coreMembership: "Mindkore CORE Membership",
        apexMembership: "Mindkore APEX Membership",

        save: "⭐ 5% korting • Bouwt op tot 15%",
        step: "STAP",

    },

    de: {

        membership: "Mindkore Mitgliedschaft",
        coreMembership: "Mindkore CORE Mitgliedschaft",
        apexMembership: "Mindkore APEX Mitgliedschaft",

        save: "⭐ 5 % Rabatt • Steigt mit der Zeit auf bis zu 15 %",
        step: "SCHRITT",

    }

};

const t = translations[language];

/* ========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    initializeMindkoreMembership();

});

/* ========================================================== */

function initializeMindkoreMembership() {

    renameTexts();
    updateSubscriptionWidget();

}

/* ==========================================================
   Custom text replacements not supported by Easy Subscriptions
   ========================================================== */

function renameTexts() {

    /* ------------------------------------------------------
       Determine current membership name from active variant
       ------------------------------------------------------ */

    const variantId = document.querySelector('input[name="id"]')?.value;

    let membershipName = t.membership;

    switch (variantId) {

        case "57168889315702":
            membershipName = t.coreMembership;
            break;

        case "57168889348470":
            membershipName = t.apexMembership;
            break;

    }

    /* ------------------------------------------------------
       Membership subtitle
       ------------------------------------------------------ */

    document.querySelectorAll(".esa_subscription_text_span_g").forEach(el => {

        el.innerHTML = `
            ${membershipName}
            <br>
            <span class="mk-save10">${t.save}</span>
        `;

    });

    /* ------------------------------------------------------
       Membership benefits
       ------------------------------------------------------ */

    document.querySelectorAll(".eca_sqd_ul").forEach(tierList => {

        if (!tierList.parentNode.querySelector(".mk-membership-benefits")) {

            const benefits = document.createElement("div");

            benefits.className = "mk-membership-benefits";

            if (language === "nl") {

                benefits.innerHTML = `
                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span><strong>Direct 5% korting</strong></span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Meteen opzegbaar of te pauzeren</span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Automatische, wereldwijde levering op jouw gekozen schema</span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Elke verlenging verhoogt je korting met <strong>2%</strong>, tot maximaal <strong>15%</strong></span>
                    </div>
                `;

            } else if (language === "de") {

                benefits.innerHTML = `
                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span><strong>Sofort 5 % Rabatt</strong></span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Jederzeit pausieren oder kündigen</span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Automatische weltweite Lieferung nach deinem Zeitplan</span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Jede Verlängerung bringt 2 % mehr Rabatt, bis zu 15 %.</span>
                    </div>
                `;

            } else {

                benefits.innerHTML = `
                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span><strong>Immediate 5% discount</strong></span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Pause or cancel anytime</span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Automatic, worldwide delivery on your schedule</span>
                    </div>

                    <div class="mk-benefit">
                        <span class="mk-check">✔</span>
                        <span>Every renewal increases your discount by <strong>2%</strong>, up to <strong>15%</strong></span>
                    </div>
                `;

            }

            tierList.parentNode.insertBefore(benefits, tierList);

        }

    });

}

/* ========================================================== */

function updateSubscriptionWidget() {

    const widget = document.querySelector(".selling_plan_app_container");
    const step2 = document.querySelector("#mk-step-2");
    const checkoutBadge = document.querySelector("#mk-step-badge-checkout");

    if (!widget) return;

    const visiblePlan = widget.querySelector(
        ".selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden)"
    );

    /* ------------------------------------------------------
       Show / hide subscription widget
       ------------------------------------------------------ */

    widget.style.display = visiblePlan ? "block" : "none";

    if (step2) {
        step2.style.display = visiblePlan ? "flex" : "none";
    }

    /* ------------------------------------------------------
       Detect active purchase type
       ------------------------------------------------------ */

    const quantitySection = document.querySelector(".product-form__quantity");
    const quantityBadge = document.querySelector("#mk-step-badge-quantity");
    const mainPouchBox = document.querySelector("#main-pouch-box");
    const rewardCenter = document.querySelector("#reward-center");

    let membershipSelected = false;

    if (visiblePlan) {

        const oneTimeRadio = visiblePlan.querySelector(
            '.delivery_value[data-radio-type="one_time_purchase"]'
        );

        if (oneTimeRadio) {
            membershipSelected = !oneTimeRadio.checked;
        }

    }

    /* ------------------------------------------------------
       Show / hide complete product summary box
       ------------------------------------------------------ */

    if (mainPouchBox) {
        mainPouchBox.style.display = membershipSelected ? "none" : "";
    }

    /* ------------------------------------------------------
       Show / hide complete reward grid
       ------------------------------------------------------ */

    if (rewardCenter) {
        rewardCenter.style.display = membershipSelected ? "none" : "";
    }

    /* ------------------------------------------------------
       Quantity section and step numbering
       ------------------------------------------------------ */

    if (quantitySection) {

        if (membershipSelected) {

            // CORE/APEX + Membership
            quantitySection.style.display = "none";

            if (checkoutBadge) {
                checkoutBadge.textContent = `${t.step} 3`;
            }

        } else {

            // One-time purchase
            quantitySection.style.display = "";

            if (quantityBadge) {
                quantityBadge.textContent = visiblePlan
                    ? `${t.step} 3`
                    : `${t.step} 2`;
            }

            if (checkoutBadge) {
                checkoutBadge.textContent = visiblePlan
                    ? `${t.step} 4`
                    : `${t.step} 3`;
            }

        }

    }

    /* ------------------------------------------------------
       Re-apply customizations after Easy Subscriptions updates
       ------------------------------------------------------ */

    renameTexts();
    translateDynamicTexts();

}

/* ==========================================================
   Translate dynamic Easy Subscription texts
   ========================================================== */

function translateDynamicTexts() {

    let replacements = [];

    if (language === "nl") {

        replacements = [

            ["Delivery every 35 days, Pay 35 days", "Levering elke 35 dagen, betaal eens per 35 dagen"],
            ["Delivery every 50 days, Pay 50 days", "Levering elke 50 dagen, betaal eens per 50 dagen"],
            ["Delivery every 65 days, Pay 65 days", "Levering elke 65 dagen, betaal eens per 65 dagen"],

            ["Delivery every 70 days, Pay 70 days", "Levering elke 70 dagen, betaal eens per 70 dagen"],
            ["Delivery every 100 days, Pay 100 dagen", "Levering elke 100 dagen, betaal eens per 100 dagen"],
            ["Delivery every 130 days, Pay 130 days", "Levering elke 130 dagen, betaal eens per 130 dagen"],

            ["days", "dagen"],
            ["day", "dag"]

        ];

    } else if (language === "de") {

        replacements = [

            ["Delivery every 35 days, Pay 35 days", "Lieferung alle 35 Tage, Zahlung alle 35 Tage"],
            ["Delivery every 50 days, Pay 50 days", "Lieferung alle 50 Tage, Zahlung alle 50 Tage"],
            ["Delivery every 65 days, Pay 65 days", "Lieferung alle 65 Tage, Zahlung alle 65 Tage"],

            ["Delivery every 70 days, Pay 70 days", "Lieferung alle 70 Tage, Zahlung alle 70 Tage"],
            ["Delivery every 100 days, Pay 100 days", "Lieferung alle 100 Tage, Zahlung alle 100 Tage"],
            ["Delivery every 130 days, Pay 130 days", "Lieferung alle 130 Tage, Zahlung alle 130 Tage"],

            ["Lieferung alle 35 Tage, Zahlen 35 Tage", "Lieferung alle 35 Tage, Zahlung alle 35 Tage"],
            ["Lieferung alle 50 Tage, Zahlen 50 Tage", "Lieferung alle 50 Tage, Zahlung alle 50 Tage"],
            ["Lieferung alle 65 Tage, Zahlen 65 Tage", "Lieferung alle 65 Tage, Zahlung alle 65 Tage"],
            ["Lieferung alle 70 Tage, Zahlen 70 Tage", "Lieferung alle 70 Tage, Zahlung alle 70 Tage"],
            ["Lieferung alle 100 Tage, Zahlen 100 Tage", "Lieferung alle 100 Tage, Zahlung alle 100 Tage"],
            ["Lieferung alle 130 Tage, Zahlen 130 Tage", "Lieferung alle 130 Tage, Zahlung alle 130 Tage"],

            ["days", "Tage"],
            ["day", "Tag"]

        ];

    } else {

        replacements = [

            ["Delivery every 35 days, Pay 35 days", "Delivery every 35 days, pay once every 35 days"],
            ["Delivery every 50 days, Pay 50 days", "Delivery every 50 days, pay once every 50 days"],
            ["Delivery every 65 days, Pay 65 days", "Delivery every 65 days, pay once every 65 days"],

            ["Delivery every 70 days, Pay 70 days", "Delivery every 70 days, pay once every 70 days"],
            ["Delivery every 100 days, Pay 100 days", "Delivery every 100 days, pay once every 100 days"],
            ["Delivery every 130 days, Pay 130 days", "Delivery every 130 days, pay once every 130 days"]

        ];

    }

    document.querySelectorAll(".selling_plan_app_container *").forEach(el => {

        if (el.children.length > 0) return;

        let text = el.textContent;

        replacements.forEach(([from, to]) => {

            text = text.replaceAll(from, to);

        });

        if (text !== el.textContent) {

            el.textContent = text;

        }

    });

    /* ------------------------------------------------------
       Loyalty tier formatting
       ------------------------------------------------------ */

    document.querySelectorAll(".eca_sqd_ul").forEach(list => {

        if (language === "nl") {

            list.innerHTML = `
                <li>🌱 <strong>Seedling</strong> · <span class="mk-tier-discount">7%</span> <span class="mk-tier-note">na 1e verlenging</span></li>
                <li>🌿 <strong>Sprout</strong> · <span class="mk-tier-discount">9%</span> <span class="mk-tier-note">na 2e verlenging</span></li>
                <li>🌳 <strong>Sapling</strong> · <span class="mk-tier-discount">11%</span> <span class="mk-tier-note">na 3e verlenging</span></li>
                <li>🌴 <strong>Tree</strong> · <span class="mk-tier-discount">13%</span> <span class="mk-tier-note">na 4e verlenging</span></li>
                <li>🌲 <strong>Evergreen</strong> · <span class="mk-tier-discount">15%</span> <span class="mk-tier-note">na 5e verlenging</span></li>
            `;

        } else if (language === "de") {

            list.innerHTML = `
                <li>🌱 <strong>Seedling</strong> · <span class="mk-tier-discount">7 %</span> <span class="mk-tier-note">nach 1 Verlängerung</span></li>
                <li>🌿 <strong>Sprout</strong> · <span class="mk-tier-discount">9 %</span> <span class="mk-tier-note">nach 2 Verlängerungen</span></li>
                <li>🌳 <strong>Sapling</strong> · <span class="mk-tier-discount">11 %</span> <span class="mk-tier-note">nach 3 Verlängerungen</span></li>
                <li>🌴 <strong>Tree</strong> · <span class="mk-tier-discount">13 %</span> <span class="mk-tier-note">nach 4 Verlängerungen</span></li>
                <li>🌲 <strong>Evergreen</strong> · <span class="mk-tier-discount">15 %</span> <span class="mk-tier-note">nach 5 Verlängerungen</span></li>
            `;

        } else {

            list.innerHTML = `
                <li>🌱 <strong>Seedling</strong> · <span class="mk-tier-discount">7%</span> <span class="mk-tier-note">after 1 renewal</span></li>
                <li>🌿 <strong>Sprout</strong> · <span class="mk-tier-discount">9%</span> <span class="mk-tier-note">after 2 renewals</span></li>
                <li>🌳 <strong>Sapling</strong> · <span class="mk-tier-discount">11%</span> <span class="mk-tier-note">after 3 renewals</span></li>
                <li>🌴 <strong>Tree</strong> · <span class="mk-tier-discount">13%</span> <span class="mk-tier-note">after 4 renewals</span></li>
                <li>🌲 <strong>Evergreen</strong> · <span class="mk-tier-discount">15%</span> <span class="mk-tier-note">after 5 renewals</span></li>
            `;

        }

    });

    /* ------------------------------------------------------
       Remove unwanted price suffixes
       ------------------------------------------------------ */

    document.querySelectorAll(".selling_plan_app_container *").forEach(el => {

        const text = el.textContent.trim().toLowerCase();

        if (
            text === "per stuk" ||
            text === "/per stuk" ||
            text === "each" ||
            text === "/each" ||
            text === "je" ||
            text === "/je" ||
            text === "pro stück" ||
            text === "/pro stück"
        ) {
            el.remove();
        }

    });

}

/* ========================================================== */

setInterval(updateSubscriptionWidget, 350);